import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TEAM_POST_REQUEST = 'POST_TEAM_REQUEST';
export const TEAM_POST_FAILURE = 'POST_TEAM_FAILURE';
export const TEAM_POST_SUCCESS = 'POST_TEAM_SUCCESS';

export const postTeam = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.TEAM.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Team successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {
        type: TEAM_POST_REQUEST,
    }
};

const postFailure = (error) => {
    return {
        type: TEAM_POST_FAILURE,
        error,
    }
};

const postSuccess = (team) => {
    return {
        type: TEAM_POST_SUCCESS,
        team,
    }
};